import { useEffect } from 'react';

import { useLatest } from './useLatest';

// Add more keys here as necessary
//
// Complete list:
// https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
type KeyName = 'Escape' | 'Enter';

export function useOnWindowKeyDown(
  keys: KeyName[],
  callback: ((event: KeyboardEvent) => void) | undefined,
) {
  const keydownRef = useLatest((event: KeyboardEvent) => {
    if (!callback) return;
    if (keys.includes(event.key as KeyName)) callback(event);
  });

  useEffect(() => {
    const options = { capture: true };
    const fn = (e: KeyboardEvent) => keydownRef.current(e);

    window.addEventListener('keydown', fn, options);

    return () => {
      window.removeEventListener('keydown', fn, options);
    };
  }, [keydownRef]);
}
